import BaseService from "/src/api-services/base-service";

// const user = JSON.parse(localStorage.getItem('user') || '[]')
// const initialState = user
//     ? { status: { loggedIn: true }, user }
//     : { status: { loggedIn: false }, user: null };

export const baseService = {
    namespaced: true,
    // state: initialState,
    actions: {
        sendNewAppeal({ commit }, appeal) {
            return BaseService.sendNewAppeal(appeal).then(
                response => {
                    commit('sendNewAppealSuccess', appeal);
                    return Promise.resolve(response.data);
                },
                error => {
                    commit('sendNewAppealFailure');
                    return Promise.reject(error);
                }
            );
        },
        sendNewReport({ commit }, report) {
            return BaseService.sendNewReport(report).then(
                response => {
                    commit('sendNewReportSuccess', report);
                    return Promise.resolve(response.data);
                },
                error => {
                    commit('sendNewReportFailure');
                    return Promise.reject(error);
                }
            );
        },
        getAllReports( {commit}){
            return BaseService.getAllReports().then(
                response => {
                    commit('getAllReportsSuccess');
                    return Promise.resolve(response.data);
                },
                error => {
                    commit('getAllReportsFailure');
                    return Promise.reject(error);
                }
            );
        },
        // logout({ commit }) {
        //     AuthService.logout();
        //     commit('logout');
        // },

    },
    mutations: {
        getAllReportsSuccess(){

        },
        getAllReportsFailure(){

        },

        sendNewAppealFailure(){

        },
        sendNewAppealSuccess(){

        },
        sendNewReportFailure(){

        },
        sendNewReportSuccess(){

        }
    }
};